/* eslint-disable react/forbid-foreign-prop-types */
import PropTypes from 'prop-types';
import InputProps from 'admin-components/proptypes/groups/input';
import ThemeProps from 'admin-components/proptypes/groups/theme';

export const propTypes = {
  ...InputProps.propTypes,
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  async: PropTypes.bool,
  creatable: PropTypes.bool,
  multiple: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired
    })
  ),
  loadOptions: PropTypes.func,
  theme: PropTypes.shape({
    ...ThemeProps.propTypes
  }),
  fixDropdownPosition: PropTypes.bool
};

export const defaultProps = {
  ...InputProps.defaultProps,
  async: false,
  creatable: false,
  multiple: false,
  fixDropdownPosition: false
};

export const propDescriptions = {
  ...InputProps.propDescriptions,
  value: 'The value of the select field, either the option key is standard select or an array of option keys if multiple is set #data',
  async: 'Can the options provided updated asynchronously #functional',
  creatable: 'Can new options be added that arent specified in the options #functional',
  multiple: 'Can multiple values be entered into the field #functional',
  options: 'List of options that are provided to the user to select from #functional',
  loadOptions:
    'Callback function with the search criteria every time a character is entered, used to update the suggested options, almost like a search type functionality #functional',
  theme: ThemeProps.propDescriptions,
  fixDropdownPosition:
    'Set options menu to position fixed and float it above everything else ~ Note: caveat to this is that it sets width to natural instead of matching parent width #visual'
};
